/* eslint-disable no-undef */
// ====== Utility Functions ======
console.log("s1");
function I(id) {
  return document.getElementById(id);
}

function FindByClassName(className) {
  return document.getElementsByClassName(className);
}

function mbpsToAmount(mbps) {
  return 1 - 1 / Math.pow(1.3, Math.sqrt(mbps));
}

function msToAmount(ms) {
  return 1 - 1 / Math.pow(1.08, Math.sqrt(ms));
}

// ====== Drawing Meter Function ======
function drawMeter(canvas, amount, bgColor, fgColor, progress, progressColor) {
  const ratio = window.devicePixelRatio || 1;
  const width = canvas.clientWidth * ratio;
  const height = canvas.clientHeight * ratio;
  const scale = height * 0.0055;

  if (canvas.width === width && canvas.height === height) {
    ctx.clearRect(0, 0, width, height);
  } else {
    canvas.width = width;
    canvas.height = height;
  }

  const centerX = canvas.width / 2;
  const centerY = canvas.height - 58 * scale;
  const radius = canvas.height / 1.8 - 16 * scale;

  ctx.beginPath();
  ctx.strokeStyle = bgColor;
  ctx.lineWidth = 16 * scale;
  ctx.arc(centerX, centerY, radius, -Math.PI * 1.1, Math.PI * 0.1);
  ctx.stroke();

  ctx.beginPath();
  ctx.strokeStyle = fgColor;
  ctx.lineWidth = 16 * scale;
  ctx.arc(
    centerX,
    centerY,
    radius,
    -Math.PI * 1.1,
    amount * Math.PI * 1.2 - Math.PI * 1.1
  );
  ctx.stroke();

  if (typeof progress !== "undefined") {
    ctx.fillStyle = progressColor;
    ctx.fillRect(
      canvas.width * 0.3,
      canvas.height - 16 * scale,
      canvas.width * 0.4 * progress,
      4 * scale
    );
  }
}

// ====== Variables for UI and Colors ======
const meterBk = "#E0E0E0";
const dlColor = "#6060AA";
const ulColor = "#309030";
const pingColor = "#AA6060";
const jitColor = "#AA6060";
const progColor = "#EEEEEE";

// ====== Gauge Objects ======
let gaugePS = {
  value: 0,
  draw: function () {
    drawMeter(
      I("gauge-ps"),
      mbpsToAmount(this.value),
      meterBk,
      dlColor,
      data && data.testState === 1 ? Number(data.dlProgress) || 0 : 0,
      progColor
    );
  },
};

let gaugeUp = {
  value: 0,
  draw: function () {
    drawMeter(
      I("gauge-Up"),
      mbpsToAmount(this.value),
      meterBk,
      ulColor,
      data && data.testState === 3 ? Number(data.ulProgress) || 0 : 0,
      progColor
    );
  },
};

let gaugePing = {
  value: 0,
  draw: function () {
    drawMeter(
      I("gauge-Ping"),
      msToAmount(this.value),
      meterBk,
      pingColor,
      data && data.testState === 2 ? Number(data.pingProgress) || 0 : 0,
      progColor
    );
  },
};

let gaugeJit = {
  value: 0,
  draw: function () {
    drawMeter(
      I("gauge-Jit"),
      msToAmount(this.value),
      meterBk,
      jitColor,
      data && data.testState === 2 ? Number(data.pingProgress) || 0 : 0,
      progColor
    );
  },
};

// ====== Test Helper Functions ======
const testHelper = {
  saveLinkForm: "saveResultForm",
  isValidHost: false,

  updateQueryStringParameter(url, param, value) {
    const regex = new RegExp("([?&])" + param + "=.*?(&|$)", "i");
    const separator = url.indexOf("?") !== -1 ? "&" : "?";
    return url.match(regex)
      ? url.replace(regex, "$1" + param + "=" + value + "$2")
      : url + separator + param + "=" + value;
  },

  onTestFinished() {
    if (this.isValidHost) {
      const dl = parseFloat(I("dlText").textContent) || 0;
      const ul = parseFloat(I("ulText").textContent) || 0;
      const ping = parseFloat(I("pingText").textContent) || 0;
      const jit = parseFloat(I("jitText").textContent) || 0;

      if (dl && ul) {
        const form = I(this.saveLinkForm);
        let actionUrl = decodeURIComponent(form.action);
        actionUrl = this.updateQueryStringParameter(actionUrl, "Download", dl);
        actionUrl = this.updateQueryStringParameter(actionUrl, "Upload", ul);
        actionUrl = this.updateQueryStringParameter(actionUrl, "Ping", ping);
        actionUrl = this.updateQueryStringParameter(actionUrl, "Jitter", jit);
        form.action = actionUrl;
        form.className = form.className.replace("hidden", "");
      }
    }
  },

  onTestStart() {
    if (this.isValidHost) {
      I(this.saveLinkForm).className = "hidden";
    }
  },

  init() {
    const domainRegex = /.*\.sepanta\.com$/i;
    // eslint-disable-next-line no-restricted-globals
    const url = new URL(location);
    let returnUrl = (url.search || "").split("returnUrl=")[1];

    if (returnUrl) {
      returnUrl = decodeURIComponent(returnUrl);
      try {
        const host = new URL(returnUrl).host;
        this.isValidHost = domainRegex.test(host);
        I(this.saveLinkForm).action = this.isValidHost ? returnUrl : "/";
      } catch (e) {
        // Invalid URL, skip
      }
    }
  },
};

// ====== Start/Stop Speed Test ======
let w = null;
let data = null;

function startStop() {
  if (w !== null) {
    w.postMessage("abort");
    w = null;
    data = null;
    initUI();
  } else {
    w = new Worker("/speedtest_worker.js");
    console.log("wwwwwwwww", w);
    w.postMessage("start");
    testHelper.onTestStart();

    w.onmessage = function (e) {
      try {
        data = JSON.parse(e.data);
        const t = data.testState;

        if (t >= 4) {
          I("startStopBtn").className = "btn finished";
          w = null;
          updateUI(true);
          testHelper.onTestFinished();
        }
      } catch (error) {
        // console.error("Error processing worker data:", error);
      }
    };
  }
}

// ====== Update UI ======
function updateUI(callback, force = false) {
  if (force || (data && w)) {
    if (!data) return;

    const t = data.testState;

    if (callback) {
      const newResults = {
        download: data.dlStatus || 0,
        upload: data.ulStatus || 0,
        ping: data.pingStatus || 0,
        jitter: data.jitterStatus || 0,
      };
      callback(newResults);
    }

    gaugePS.value = data.dlStatus || 0;
    //  gaugePS.draw();
    // gaugePS.update({
    //   arcFillPercent: data.dlStatus,
    // });

    gaugeUp.value = data.ulStatus || 0;
    // gaugeUp.draw();
    // gaugeUp.update({
    //   arcFillPercent: data.ulStatus,
    // });

    gaugePing.value = data.pingStatus || 0;
    // gaugePing.draw();
    // gaugePing.update({
    //   arcFillPercent: data.pingStatus,
    // });

    gaugeJit.value = data.jitterStatus || 0;
    // gaugeJit.update({
    //   arcFillPercent: data.jitterStatus,
    // });

    //gaugeJit.draw();

    // I("dlText").textContent =
    //   t === 1 && data.dlStatus === 0 ? "..." : data.dlStatus;
    // I("ulText").textContent =
    //   t === 3 && data.ulStatus === 0 ? "..." : data.ulStatus;
    // I("pingText").textContent = data.pingStatus || 0;
    // I("jitText").textContent = data.jitterStatus || 0;

    const dialEls = FindByClassName("fg-dial");
    for (const el of dialEls) {
      el.textContent = data.dlStatus || 0;
    }
  }
}

let updateInterval = null;

function startUpdateLoop(callback) {
  if (updateInterval) clearInterval(updateInterval);
  updateInterval = setInterval(() => {
    updateUI(callback);
  }, 500);
}

function stopUpdateLoop() {
  clearInterval(updateInterval);
}

// ====== Oscillate Animation Helper ======
function oscillate() {
  return 1 + 0.02 * Math.sin(Date.now() / 100);
}
export { startUpdateLoop, stopUpdateLoop };

// ====== RequestAnimationFrame Setup ======
window.requestAnimationFrame =
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (callback) {
    setTimeout(callback, 1000 / 60);
  };

// ====== Frame Loop ======
function frame() {
  requestAnimationFrame(frame);
  updateUI();
}

// ====== Initialize UI ======
function initUI() {
  // drawMeter(I("gauge-Up"), 0, meterBk, ulColor, 0);
  // drawMeter(I("gauge-Ping"), 0, meterBk, pingColor, 0);
  // drawMeter(I("gauge-Jit"), 0, meterBk, jitColor, 0);
  // drawMeter(I("gauge-ps"), 0, meterBk, dlColor, 0);

  I("dlText").textContent = "";
  I("ulText").textContent = "";
  I("pingText").textContent = "";
  I("jitText").textContent = "";
  testHelper.init();
}

// ====== Poll Worker Status Regularly ======
setInterval(() => {
  if (w) w.postMessage("status");
}, 200);

// ====== Start Main Frame Loop ======
frame();

// ====== Export Functions ======
export {
  I,
  FindByClassName,
  drawMeter,
  mbpsToAmount,
  msToAmount,
  startStop,
  updateUI,
  oscillate,
  frame,
  initUI,
  testHelper,
};
